import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDeleteAirlines } from "../../api/apiAirlines";
import parseError from "../../utils/parseError";

const useDeleteAllAirlines = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAllAirlinesAction, isPending } = useMutation({
        mutationFn: massDeleteAirlines,
        onSuccess: (res) => {
            const message = res?.message || "Airlines deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete airlines");
        },
    });

    return { deleteAllAirlines: deleteAllAirlinesAction, isPending };
};

export default useDeleteAllAirlines;
